define(function(require) {
  const tpl = require('./templates/t_cpv_payment_summary.hbs');

  const rowView = require('./v_itv_payment_summary');
  const fee_collection = require('civicsCollections/portal/portal_fee_collection');

  return Marionette.CompositeView.extend({
    template: tpl,
    config: {},
    tagName: 'div',
    childView: rowView,
    className: 'selected-fees-container',
    childViewContainer: '.fee-list',
    events: {
      // 'click @ui.expandButton':'expandButtonClicked'
    },
    childEvents: {
      'addFee': 'recalculateTotal'
    },
    ui: {
      'expandButton': '.expand-fee',
      'expandIcon': '.expand-collapse',
      'expandableList': '.collapsible-content',
      'feesCount': '.selected-fees-count',
      'feeTotal': '.fee-total',
      'priceLarge': '.price-large',
      'feeTitle': '.fee-content .fees-title',
      'feeToggle': '.fees-control-toggle',
      'summaryTotalFees': '.summary-total-fees'
    },
    initialize: function(options) {
      var self = this;
      $(this.ui.feeTitle).attr('id', 'FeeListTitle_PaymentSummary');
      this.config = options.config;
      this.feesCollection = options.feesCollection;
      this.collection = options.selectedFees; //only fees that are selected will be checked
      this.feesCollection.each(function(fee) {
        if (fee.get('payInPortal') != false) { //if true or undefined
          if (fee.get('parent')) {
            fee.get('childFees').each(function(childFee) {
              if (childFee.get('payInPortal')) { //if true
                self.collection.add(childFee);
              }
            })
          } else {
            self.collection.add(fee);
          }
        }
      });
    },
    onShow: function() {
      this.recalculateTotal();
    },
    onRender: function () {
      this.$el.rhythmThemeInitCivics();
      this.$el.rhythmThemeInit();

    },
    expandButtonClicked: function(e) {
      e.stopPropagation();
      e.preventDefault();
      var collapsed = this.ui.expandIcon.hasClass('coll');
      if (collapsed) {
        this.ui.expandIcon.removeClass('coll');
        this.ui.expandIcon.addClass('exp');
        this.ui.expandableList.removeClass('collapsed');
        this.ui.expandableList.addClass('expanded');
      } else {
        this.ui.expandIcon.removeClass('exp');
        this.ui.expandIcon.addClass('coll');
        this.ui.expandableList.removeClass('expanded');
        this.ui.expandableList.addClass('collapsed');
      }
    },
    recalculateTotal: function(childView) {
      var totalCount = 0;
      var totalAmount = 0;
      this.collection.each(function(fee) {
        if (fee.get('checked')) {
          totalCount++;
          totalAmount += Number(fee.get('totalUnpaidAmount'));
        }
      });
      this.ui.feesCount.html(totalCount);
      this.ui.summaryTotalFees.attr('aria-live','polite');
      var total = Handlebars.helpers['global:formatMoney'](totalAmount);
      this.ui.priceLarge.html(total);
      var totalText = totalCount + " " +
				Handlebars.helpers['global:pluralize'](totalCount, i18n.t("CIVICS.DASHBOARD_CURRENT_STATEMENT.FEE_SELECTED"),
				i18n.t("CIVICS.DASHBOARD_CURRENT_STATEMENT.FEES_SELECTED"));
      this.ui.feeTitle.text(totalText);
      this.ui.feeToggle.attr('aria-label',totalText);
    },
    templateHelpers: function() {
      return {

      }
    },

  });
});
